import React, { useEffect, useState } from 'react';
export function CountdownBanner() {
  const [timeLeft, setTimeLeft] = useState({
    days: 0,
    hours: 0,
    minutes: 0,
    seconds: 0
  });
  const [spotsLeft] = useState(12);
  useEffect(() => {
    // Fecha límite del acceso gratuito: 21 de julio de 2026, 23:59:59
    const targetDate = new Date('2026-07-21T23:59:59');
    const interval = setInterval(() => {
      const now = new Date().getTime();
      const distance = targetDate.getTime() - now;
      setTimeLeft({
        days: Math.floor(distance / (1000 * 60 * 60 * 24)),
        hours: Math.floor(distance % (1000 * 60 * 60 * 24) / (1000 * 60 * 60)),
        minutes: Math.floor(distance % (1000 * 60 * 60) / (1000 * 60)),
        seconds: Math.floor(distance % (1000 * 60) / 1000)
      });
    }, 1000);
    return () => clearInterval(interval);
  }, []);
  return <div className="sticky top-0 z-50 w-full bg-brand-pink text-white py-3 px-4 text-center shadow-[0_0_15px_rgba(255,0,127,0.5)]" data-id="element-50">
      <div className="max-w-5xl mx-auto flex flex-col md:flex-row items-center justify-center gap-2 md:gap-6 text-sm md:text-base font-bold tracking-wide" data-id="element-51">
        <p data-id="element-52">ACCESO GRATUITO EXPIRA PRONTO.</p>
        <div className="flex items-center gap-4 bg-black/20 px-4 py-1.5 rounded-full" data-id="element-53">
          <div className="flex gap-2 tabular-nums" data-id="element-54">
            <span data-id="element-55">{timeLeft.days}d</span>:
            <span data-id="element-56">{timeLeft.hours.toString().padStart(2, '0')}h</span>:
            <span data-id="element-57">{timeLeft.minutes.toString().padStart(2, '0')}m</span>:
            <span data-id="element-58">{timeLeft.seconds.toString().padStart(2, '0')}s</span>
          </div>
          <span className="hidden md:inline text-white/50" data-id="element-59">|</span>
          <span className="text-yellow-300" data-id="element-60">QUEDAN {spotsLeft} LUGARES</span>
        </div>
      </div>
    </div>;
}